import { Server } from '../Utils';
import * as AuthHelper from './APIHelper';

export const GetIpandDetails = () => {
    return AuthHelper.getDifferentBaseURL('/check?access_key=95f00ec423cd3e49fc07458a273aa39c', Server.ENV.ipURL);
}